'use client'

import * as React from 'react'

import { cn } from '@/utils'

import { BaseInput, baseInputCls, TBaseInputProps } from './BaseInput'

export const clone1InputCls: typeof baseInputCls = (error) =>
	cn(baseInputCls(error), 'rounded-10 [&:not(textarea)]:rounded-full')

export const Clone1Input = React.forwardRef<HTMLInputElement, TBaseInputProps>(
	({ error, className, ...props }, ref) => (
		<BaseInput
			ref={ref}
			{...props}
			className={cn(clone1InputCls(error), className)}
		/>
	),
)
Clone1Input.displayName = 'Clone1Input'
